// @flow
class NumberUtils {
    static isNumeric(value: any): boolean {
        return !isNaN(parseFloat(value)) && isFinite(value);
    }
}

export default NumberUtils;
